import application from './application.json';
import common from './common.json';
import errors from './errors.json';
import footer from './footer.json';
import header from './header.json';
import modals from './modals.json';
import navigation from './navigation.json';
import policy from './policy.json';
import productPackage from './product-package.json';
import productSelection from './product-selection.json';
import quotes from './quotes.json';
import quotesItem from './quotes-item.json';
import quotesRating from './quotes-rating.json';
import quotesSettings from './quotes-settings.json';
import quotesSettingsAbsence from './quotes-settings-absence.json';
import quotesSettingsCoverage from './quotes-settings-coverage.json';
import quotesSettingsEmployees from './quotes-settings-employees.json';
import quotesSidebar from './quotes-sidebar.json';
import quotesSort from './quotes-sort.json';
import quotesStatus from './quotes-status.json';
import requestOverview from './request-overview.json';
import validation from './validation.json';

// Merge all translations into a single namespace structure
// This maintains backward compatibility with existing t() calls
export default {
	translation: {
		common,
		contact: {
			modal: modals.contact
		},
		navigation,
		header,
		modals: {
			sectorCode: modals.sectorCode,
			kvk: modals.kvk,
			wageInfo: modals.wageInfo,
			slstCoverage: modals.slstCoverage,
			premiumPercentage: modals.premiumPercentage,
			dialog: modals.dialog,
			contactDetailsDuringLoad: modals.contactDetailsDuringLoad,
			share: modals.share
		},
		policy,
		quotes: {
			...quotes,
			status: quotesStatus,
			item: quotesItem,
			rating: quotesRating,
			sort: quotesSort,
			sidebar: quotesSidebar,
			settings: {
				...quotesSettings,
				employees: quotesSettingsEmployees,
				absence: quotesSettingsAbsence,
				coverage: quotesSettingsCoverage
			}
		},
		application,
		requestOverview,
		productSelection,
		productPackage,
		errors,
		validation,
		footer
	}
};
